import { useParkingFeeRateTypeEnum } from '@services/parkingFee'
import { Select, SelectProps } from '@shared/Form/Select'

export const ParkingFeeRateTypeSelect = (props: SelectProps<number[]>) => {
  const { data } = useParkingFeeRateTypeEnum()

  return (
    <Select {...props}>
      {(data || []).map(({ id, label }) => (
        <Select.Option key={id} value={id}>
          {label}
        </Select.Option>
      ))}
    </Select>
  )
}

export default ParkingFeeRateTypeSelect
